import { Alert, AlertTitle } from '@mui/material'

export const NotAllowedAlert = () => {
    return (
        <div className="flex justify-center">
            <Alert severity="error">
                <AlertTitle>Not Allowed</AlertTitle>The account you are
                currently logged in with is not allowed to view / edit this
                collection
            </Alert>
        </div>
    )
}
